import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CharitableContributionScreenComponent } from './charitable-contribution.component';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { FlexLayoutModule } from '@angular/flex-layout';
import { CharitableContributionRouter } from './charitable-contribution.router';
import { reducers } from './state/charitable-contribution.selectors';
import { ConfirmDeactivateGuard } from '../../commons/guards';

@NgModule({
  imports: [
    CharitableContributionRouter,
    StoreModule.forFeature('charitableContribution', reducers),
  ],
  providers: [ConfirmDeactivateGuard],
  declarations: []
})
export class CharitableContributionScreenModule { }